export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/?limit=100")
        .then(response => {
          context.commit("setCourses", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getDetails(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/${id}`)
        .then(response => {
          context.commit("setCourse", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  getCategories(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/categories?limit=100")
        .then(response => {
          context.commit("setCategories", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  setProgress(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/students/progress", data)
        .then(resolve)
        .catch(reject);
    });
  },

  getLastLessons(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/students/last-lessons")
        .then(response => {
          context.commit("setLastLessons", response.data);
          resolve();
        })
        .catch(reject);
    });
  },
  search(context, query) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/search/?search=" + query)
        .then(response => {
          resolve(response.data.results);
        })
        .catch(reject);
    });
  }
};
